import React, { useEffect, useRef } from 'react'
import CaluButton from '@/components/styledComponents/CaluButton'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'

import PropTypes from 'prop-types'

import s from './styles.module.scss'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const CaluModal = ({
  open,
  setOpen,
  onClose,
  children,
  title,
  textConfirmationButton,
  maxWidth = 'sm',
  hideCloseButton,
  disableEscapeKeyDown = false,
  keepOpen = false,
  isLoading = false,
  disabled = false,
  functionInHandleClose,
}) => {
  const descriptionElementRef = useRef(null)

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef
      if (descriptionElement !== null) {
        descriptionElement.focus()
      }
    }
  }, [open])

  const handleClose = (e) => {
    if (keepOpen) return e.stopPropagation()

    if (functionInHandleClose) {
      functionInHandleClose()
    }

    setOpen(false)
  }

  const handleConfirmation = async () => {
    await onClose()
    setOpen(false)
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={'paper'}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        disableEscapeKeyDown={disableEscapeKeyDown}
        TransitionComponent={Transition}
        classes={{ paper: s.paperProps }}
        maxWidth={maxWidth}
      >
        <DialogTitle id="scroll-dialog-title" className={s.dialogTitle}>
          <div>{title || ''}</div>
          {!hideCloseButton && (
            <Button onClick={handleClose} className={s.closeBtn}>
              X
            </Button>
          )}
        </DialogTitle>
        <DialogContent dividers className={s.modalContent}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            className={s.dialogContentText}
            component="div"
          >
            {children}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={s.sectionButtons}>
          {textConfirmationButton && (
            <CaluButton
              color="primary"
              onClick={handleConfirmation}
              size="large"
              loading={isLoading}
              disabled={isLoading || disabled}
            >
              {textConfirmationButton}
            </CaluButton>
          )}
        </DialogActions>
      </Dialog>
    </div>
  )
}

CaluModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  textConfirmationButton: PropTypes.string,
  maxWidth: PropTypes.string,
  hideCloseButton: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  keepOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  functionInHandleClose: PropTypes.func,
}

export default CaluModal
